import { render, staticRenderFns } from "./videoConfigure.vue?vue&type=template&id=16a3cb0c&scoped=true&"
import script from "./videoConfigure.vue?vue&type=script&lang=js&"
export * from "./videoConfigure.vue?vue&type=script&lang=js&"
import style0 from "./videoConfigure.vue?vue&type=style&index=0&id=16a3cb0c&scoped=true&lang=css&"
import style1 from "./videoConfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3cb0c",
  null
  
)

export default component.exports